module.exports = {
  headline: 'Allmänna villkor',
  index: [
    'Allmänt', 
    'Avtal och beställning', 
    'Inloggning och användarprofil', 
    'Personuppgifter',
    'Integritetspolicy',
    'Priser, avgifter och betalning',
    'Frakt och leverans',
    'Relation mellan Spotin AB och Kund',
    'Reklamationer och returer',
    'Ändringar av dessa villkor',
    'Tillämplig lag och tvist'
  ],
  terms: `
    <p>
    Dessa villkor har fastställts av Spotin AB den 3:e mars 2023.
    </p>

    <p>
    Spotin är en webbaserad tjänst som möjliggör för kunder att genom en och 
    samma beställning genomföra köp av produkter direkt från olika säljare. De 
    varor som kunden lägger i sin varukorg i tjänsten Spotin kan flyttas med 
    även när användaren byter från en webbplats till en annan, vilket innebär 
    att användaren kan fylla på sin varukorg med varor från olika Säljare 
    och från olika webbplatser innan man slutligen genomför sin beställning. 

    En beställning innebär att användaren kan komma att ingå köpeavtal med flera 
    olika säljare, men att all hantering ifråga om betalning och villkor för 
    leverans m.m. kring själva beställningen görs samlat vid ett och samma 
    tillfälle via tjänsten Spotin.
    </p>

    <h2 anchor>  
    1. Allmänt
    </h2>

    
    <span>
    1.1 
    </span>
    <p class="m-list">
    Dessa allmänna villkor (”Villkoren”) gäller när en kund (”Kund”) gör en 
    beställning via tjänsten Spotin (”SPOTIN”). SPOTIN tillhandahålls av 
    Spotin AB, (Org. nr: 559027-1549). Spotin AB agerar förmedlare vid avtal 
    (”Avtal”) om köp av varor som ingås mellan Kund och den eller de 
    säljare som anslutit sig till SPOTIN och som tillhandahåller produkterna i 
    fråga. Den eller de säljare som Kunden ingår Avtal med benämns nedan 
    ”Säljaren” eller ”Säljarna” och deras fullständiga identitet framgår av 
    informationen som görs tillgänglig för Kunden i samband med att 
    beställningen läggs och bekräftas genom SPOTIN.
    </p>

    <span>
    1.2 
    </span>
    <p class="m-list">
    Spotin AB reserverar sig för slutförsäljning samt eventuella bild- och 
    textfel i SPOTIN. Exempelvis fel i Säljarens produktbeskrivning, felaktiga 
    priser samt prisjusteringar (såsom förändrade priser från Säljare, 
    valutaförändringar) eller felaktig information angående om en vara finns i 
    lager. Spotin AB har rätt att korrigera sådana eventuella fel och att ändra 
    eller uppdatera informationen när som helst.
    </p>


    <span>
    1.3 
    </span>
    <p class="m-list">
    Tjänsten SPOTIN och dess gränssnitt ägs av Spotin AB. Informationen är 
    skyddad genom lag med hänsyn till tex upphovsrätt, marknadsföring och 
    varumärken, vilka kan tillhöra Spotin AB, Säljare eller tredje män. 
    Detta innebär att varumärken, firmanamn, produktnamn, bilder och grafik, 
    design, layout samt information om produkter, tjänster och annat innehåll 
    som tillhandahålls eller görs tillgängliga genom SPOTIN inte får kopieras 
    eller användas utan föregående skriftligt medgivande från Spotin AB.
    </p>





    <h2 anchor>  
    2. Avtal och beställning
    </h2>


    <span>
    2.1 
    </span>
    <p class="m-list">
    För att kunna lägga en beställning via SPOTIN måste Kunden acceptera 
    Villkoren. Genom att acceptera Villkoren förbinder sig Kunden att följa 
    Villkoren i sin helhet. 
    </p>

    <span>
    2.2 
    </span>
    <p class="m-list">
    Kunden godkänner med sin acceptans av Villkoren att denne tagit del av och 
    accepterar respektive Säljares och/eller Betalningsförmedlares villkor för 
    den lagda beställningen (se definition i punkt 5 nedan). 
    </p>

    <span>
    2.3 
    </span>
    <p class="m-list">
    Ett Avtal mellan Kund och en Säljare, för vilket dessa Villkor och 
    respektive berörd Säljares villkor tillämpas, ingås först när Kunden erlagt 
    betalning för sin beställning genom SPOTIN och mottagit skriftlig 
    orderbekräftelse via SPOTIN från den eller de Säljare som 
    tillhandahåller och ska leverera Kundens beställning. Spotin AB uppmanar 
    Kunden att spara sådan orderbekräftelse för eventuella kontakter med 
    respektive Säljares kundtjänst.
    </p>

    <span>
    2.4 
    </span>
    <p class="m-list">
    Spotin AB strävar efter att Kunden ska få orderbekräftelse senast 72 timmar 
    efter det att Kunden fullgjort och betalat en beställning i SPOTIN. 
    (Orderbekräftelse skivkas till Kund så fort alla Säljare som ingår i ordern
    har processerats sin del av ordern). En beställning kan endast bekräftas om 
    det går att fastställa Kundens bostadsadress och full betalning mottagits.
    </p>


    <h2 anchor>  
    3. Inloggning och användarprofil
    </h2>

    <span>
    3.1
    </span>
    <p class="m-list">
    Om Kunden väljer att skapa en användarprofil med SPOTIN accepterar Kunden 
    att dess användaruppgifter sparas för framtida användning i SPOTIN. Inga 
    betalningsuppgifter kommer att sparas i SPOTIN. 
    </p>

    <span>
    3.2 
    </span>
    <p class="m-list">
    Kunden ansvarar själv för hemlighållandet av sina inloggningsuppgifter för 
    SPOTIN, där sådana erbjuds, och åtar sig att se till så att ingen annan kan 
    använda dessa uppgifter för användning av SPOTIN. Användarnamn och lösenord 
    bör därför förvaras på ett sådant sätt att obehörig ej kan få tillgång till 
    informationen. Kunden ska omgående anmäla till Spotin AB om det kan 
    misstänkas att obehörig känner till Kundens lösenord. Kunden ansvarar för 
    alla köp som gjorts med dennes inloggningsuppgifter om sådan anmälan inte 
    gjorts.
    </p>

    <span>
    3.3 
    </span>
    <p class="m-list">
    Om Spotin AB misstänker att Kunden missbrukar sitt användarkonto eller sina 
    inloggningsuppgifter eller på annat sätt bryter mot Villkoren har Spotin AB 
    rätt att stänga av Kunden från SPOTIN. Spotin AB har även rätt att oavsett 
    anledning tilldela Kunden nya inloggningsuppgifter.
    </p>


    <h2 anchor>  
    4. Personuppgifter
    </h2>

    <span>
    4.1 
    </span>
    <p class="m-list">
    Kunden samtycker genom acceptans av Villkoren Spotin AB:s (i) hantering av 
    Kundens personuppgifter samt (ii) användning av cookies, allt i enlighet med 
    detta avsnitt 4. Spotin AB kan från tid till annan komma att revidera sin 
    integritetspolicy enligt punkt 5 nedan, vilken publiceras på 
    <a data-to="/support">www.spotin.com/support</a> och som Kunden då aktivt 
    måste godkänna för att den nya integritetspolicyn ska bli gällande. 
    </p>

    <span>
    4.2
    </span>
    <p class="m-list">
    Kunden slutför beställning via SPOTIN genom Spotin AB:s domän och i 
    samverkan med en extern Betalningsförmedlare. Vid beställning kan Kunden 
    komma att ombes uppge personuppgifter som är nödvändiga för att genomföra 
    beställningen. Kunden bekräftar genom att lämna sina personuppgifter 
    att uppgifterna är korrekta och fullständigt ifyllda. Kunden ansvarar för 
    felaktigt ifyllda uppgifter. 
    </p>

    <span>
    4.3
    </span> 
    <p class="m-list">
    All datainsamling som görs i SPOTIN som inte innefattar information som 
    samlas för att behandla order från Kund är anonym och kommer därför inte att 
    härledas till specifika användare. Kundens personuppgifter kommer därför 
    inte att användas i relation till insamlad data i SPOTIN.
    </p>

    <h2 anchor>  
    5. Integritetspolicy
    </h2>

    <p class="m-list">
    Vänligen se <a data-to="/privacy">spotin.com/privacy</a> för detaljer om 
    hur Spotin skyddar användardata.
    </p>

    <h2 anchor>  
    6. Priser, avgifter och betalning
    </h2>

    <span>
    6.1
    </span>
    <p class="m-list">
    Spotin AB använder sig av externa parter för tillhandahållande av 
    betalningsfunktionen för SPOTIN, (”Betalningsförmedlare”). Spotin AB äger 
    när som helst rätt att byta Betalningsförmedlare (utan att det påverkar 
    redan ingångna Avtal).
    </p>

    <span>
    6.2
    </span>
    <p class="m-list">
    Vid beställning via SPOTIN gäller de priser som förmedlas från respektive 
    Säljare. Alla priser är angivna i lokal valuta beroende på Kundens 
    geolokalisering ifall pris i lokal valuta är tillgänligt från Säljaren. 
    </p>

    <span>
    6.3
    </span>
    <p class="m-list">
    Ifall att priser inte är tillgänliga från Säljaren i Kundens lokala valuta 
    kan SPOTIN konvertera priset till Kundens lokala valuta ifall detta är 
    överenskommet med Säljaren.
    </p>

    <span>
    6.4
    </span>
    <p class="m-list">
    Alla priser inkluderar moms såvida inte köp sker mellan marknader från 
    Säljare som är lokaliserad utanför Kundens geografiska marknad. I sådant
    fall visar SPOTIN priser exkluderande moms för den specifika Säljaren och 
    informerar Kunden om detta vid ordertillfället.
    </p>

    <span>
    6.5
    </span>
    <p class="m-list">
    Totala priset vid beställningstillfället i SPOTIN inkluderar avgifter från 
    den valda Betalningsförmedlaren. Fraktavgifter från respektive Säljare anges 
    separat och i enlighet med respektive Säljares villkor.
    </p>

    <span>
    6.6
    </span>
    <p class="m-list">
    Kunder kan betala sin beställning genom de alternativ som erbjuds av SPOTIN 
    anslutna Betalningsförmedlare vid var tid, t.ex. genom faktura eller 
    kortbetalning. 
    </p>

    <span>
    6.7
    </span>
    <p class="m-list">
    Kunden kommer automatiskt att återfå de pengar som erlagts vid betalda 
    beställningar som inte kan bekräftas av respektive Säljare och som 
    således inte leder fram till något Avtal ingås.
    </p>


    <h2 anchor>  
    7. Frakt och leverans
    </h2>

    <span>
    7.1
    </span>
    <p class="m-list">
    Kunden är medveten om och accepterar att de olika Säljare som är anslutna 
    till SPOTIN och med vilka Kunden ingår Avtal med i samband med bekräftade 
    beställningar tillämpar sina egna bestämmelser vad avser villkor för 
    leverans, ångerfrist, öppet köp m.m. Sådana bestämmelser görs tillgängliga 
    för Kunden inför varje beställning och Kunden måste acceptera sådana 
    bestämmelser för att ingå Avtal. 
    </p>


    <h2 anchor>  
    8. Relation mellan Spotin AB och Kund
    </h2>

    <span>
    8.1
    </span>
    <p class="m-list">
    I förhållande till Kunden intar Spotin AB rollen endast som förmedlare av 
    information om produkter från Säljare till Kunden, samt för Kundens 
    beställning till Säljare samt därtill relaterade bekräftelse av 
    transaktioner. Spotin AB möjliggör även för Kunden att via SPOTIN lägga 
    beställningar från flera olika Säljare vid ett och samma 
    beställningstillfälle. Spotin AB intar inte rollen som Säljare eller 
    avtalspart i förhållande till Kunden vad gäller de Avtal som ingås mellan 
    Kunden och Säljare genom SPOTIN. Spotin AB ska inte hållas ansvarigt av 
    Kunden exempelvis för beställningar som inte bekräftas av en Säljare eller 
    Avtal som inte fullgörs av en Säljare eller vid fel på mottagna produkter. 
    All reklamation ska ske till berörd Säljare. Spotin AB ska heller inte 
    hållas ansvarigt av Kunden för eventuella brister i vid var tid gällande 
    Betalningsförmedlares tjänster som erbjuds inom ramen för SPOTIN.
    </p>  

    <h2 anchor>  
    9. Reklamationer och Returer
    </h2>

    <span>
    9.1
    </span>
    <p class="m-list">
    Alla returer och reklamationer av artiklar som beställts via SPOTIN ska
    göras mot respektive Säljare. 
    </p>  


    <h2 anchor>  
    10. Ändringar av villkoren
    </h2>

    <span>
    10.1
    </span>
    <p class="m-list">
    Spotin AB förbehåller sig rätten att göra ändringar i Villkoren när som 
    helst i tiden. Alla ändringar av dessa Villkor kommer att förmedlas 
    till användare genom SPOTIN och även publiceras på 
    spotin.com/terms. Ändringar gäller från det att 
    Kunden har accepterat Villkoren i samband med användning av SPOTIN.
    </p>


    <h2 anchor>  
    11. Tillämplig lag och tvist
    </h2>

    <span>
    11.1
    </span>
    <p class="m-list">
    Tvist rörande tolkningen eller tillämpningen av Villkoren ska tolkas i 
    enlighet med svensk rätt och avgöras vid allmän domstol i Sverige.
    </p>
  `,
};


// WEBPACK FOOTER //
// ./pages/content/terms_SV.js